import { Pipe, PipeTransform } from '@angular/core';
import { head, join, map, split, upperCase } from 'lodash';

@Pipe({
  name: 'initials',
  standalone: true,
})
export class InitialsPipe implements PipeTransform {
  public transform(fullName: string | undefined | null, length: number = 3): string {
    return fullName ? join(map(map(split(fullName, ' ', length), head), upperCase), '') : '';
  }
}
